import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  const login = async (username, password) => {
    const res = await api.post("/auth/login", { username, password });
    const { access_token, user: u } = res.data;
    localStorage.setItem("token", access_token);
    localStorage.setItem("user", JSON.stringify(u));
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    window.location.href = "/login";
  };

  // Verify token still valid on mount + refresh user (incl. meta_mode_override)
  useEffect(() => {
    if (user && localStorage.getItem("token")) {
      api.get("/auth/me")
        .then((r) => {
          if (r.data) {
            const fresh = r.data;
            localStorage.setItem("user", JSON.stringify(fresh));
            setUser(fresh);
          }
        })
        .catch(() => logout());
    }
  }, []); // eslint-disable-line

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
